'use strict';//Indicating browser should run only in java script mode

var EMRCommonReasonstoRemove = angular.module('EMR.CommonReasonstoRemove', [])